module.exports = __webpack_public_path__ + "media/images/guy_floating_shadow-p-500-eb9e374190fbc792a7685b2866e73586.png";